import { defineComponent as _defineComponent } from 'vue'
import {
  PropType, computed,
} from 'vue';
import { InvoiceInfo } from '@/services/billing-utils';
import i18n from '@/plugins/i18n';
import PaymentResultSuccessLayout from './PaymentResultSuccessLayout.vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'PaymentSuccessInvoice',
  props: {
  invoiceInfo: { type: Object as PropType<InvoiceInfo>, required: true },
},
  setup(__props) {

const props = __props;




const invoiceState = computed(() => {
  if (props.invoiceInfo.processing) return { processing: true };
  if (props.invoiceInfo.open) return { open: true };
  if (props.invoiceInfo.paid) return { paid: true };
  return { error: true };
});

const title = computed(() => {
  if (invoiceState.value.paid) { return i18n.t('label.thank_you'); }
  if (invoiceState.value.processing) { return i18n.t('label.payment_processing'); }
  if (invoiceState.value.open) { return i18n.t('label.oops'); }
  return i18n.t('label.oops');
});

const subtitle = computed(() => {
  if (invoiceState.value.paid) { return i18n.t('message.invoice_paid_success'); }
  if (invoiceState.value.processing) { return i18n.t('message.payment_processing'); }
  if (invoiceState.value.open) { return i18n.t('error.payment_invoice_not_closed_pay_invoice'); }
  return i18n.t('error.billing_general');
});

const icon = computed(() => {
  if (invoiceState.value.paid) { return 'mdi-checkbox-marked-circle'; }
  if (invoiceState.value.processing) { return 'mdi-alert'; }
  if (invoiceState.value.open) { return 'mdi-alert'; }
  return 'mdi-alert';
});

const iconColor = computed(() => {
  if (invoiceState.value.paid) { return 'success'; }
  if (invoiceState.value.processing) { return 'warning'; }
  if (invoiceState.value.open) { return 'error'; }
  return 'error';
});


return { __sfc: true,props, invoiceState, title, subtitle, icon, iconColor, PaymentResultSuccessLayout }
}

})